import { Configuration, LogLevel } from '@azure/msal-browser';
import { config } from '../config';

const tenantId = config.azureTenantId;
const clientId = config.azureClientId;
const apiClientId = config.apiClientId;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
  },
  cache: {
    // sessionStorage per CLAUDE.md project rule — MSAL state must not persist across tabs.
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (_level, message) => {
        console.debug('[MSAL]', message);
      },
    },
  },
};

// Single source of truth for the API scope — shared by loginRequest (acquired
// during interactive sign-in) and apiTokenRequest (silent re-acquire).
const apiScope = `api://${apiClientId}/access_as_user`;

// Login requests the API scope up front so consent + an API-scoped token are
// obtained during the interactive sign-in itself. Without this, the first
// acquireTokenSilent call for the API scope (see useAuth/getAccessToken) can miss
// and fall back to acquireTokenRedirect — a second, unwanted interactive prompt
// right after login (#13569).
export const loginRequest = {
  scopes: ['openid', 'profile', apiScope],
};

// Silent re-acquire of the API token (roles lookup, useApi calls).
export const apiTokenRequest = {
  scopes: [apiScope],
};
